import { signal } from "@preact/signals";

/** Set by the service-worker registration when a new build is waiting; calling it reloads into the new version. */
export const updateAvailable = signal<(() => void) | null>(null);
